import { render, staticRenderFns } from "./EndStep.vue?vue&type=template&id=0999070c&scoped=true"
import script from "./EndStep.vue?vue&type=script&lang=ts"
export * from "./EndStep.vue?vue&type=script&lang=ts"
import style0 from "./EndStep.vue?vue&type=style&index=0&id=0999070c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0999070c",
  null
  
)

export default component.exports